<template>
  <div>
    <!-- filter -->
    <div class="row">
      <div class="col-md-2">
        <date-input v-model="searchForm.paid_at_start" alias="Data Inicial" />
      </div>
      <div class="col-md-2">
        <date-input v-model="searchForm.paid_at_end" alias="Data Final" />
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-sm btn-primary mr-3"
            @click="showFilters = !showFilters"
          >
            <i class="fas fa-filter" /> Mais Filtros
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="select()"
          >
            <i class="fas fa-search" /> Pesquisar
          </button>
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-end justify-content-end">
        <div class="form-group">
          <b-dropdown
            v-if="this.$acl.can('accountTransactionCreateEdit')"
            size="sm"
            class="mr-2"
            variant="success"
          >
            <template v-slot:button-content>
              <i class="fas fa-plus" /> Novo
            </template>
            <b-dropdown-item
              @click="insertAccountTransaction(searchForm.account_id)"
            >
              <i class="fas fa-plus" />
              Novo Lançamento
            </b-dropdown-item>

            <b-dropdown-item
              @click="openAccountTransaferForm(searchForm.account_id)"
            >
              <i class="fas fa-exchange-alt" />
              Transferência
            </b-dropdown-item>
          </b-dropdown>

          <button
            class="btn btn-sm btn-primary mr-2"
            @click="openAccountResume"
            v-if="canManageAccounts"
          >
            <i class="fas fa-equals" />
            Resumo
          </button>
        </div>
      </div>
    </div>
    <b-collapse v-model="showFilters">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <date-input
                    v-model="searchForm.created_at_start"
                    alias="Data Criação Inicial"
                  />
                </div>
                <div class="col-md-4">
                  <date-input
                    v-model="searchForm.created_at_end"
                    alias="Data Criação Final"
                  />
                </div>
                <div class="col d-flex align-items-end">
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'1'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Dinheiro</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'2'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Cheque</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'3'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Cartão Crédito</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'4'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Cartão Débito</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'5'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Crediário</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'15'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Boleto Bancário</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'16'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Depósito Bancário</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'17'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Pix</small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'18'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Carteira Digital </small>
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="d-block d-md-inline"
                    switch
                    inline
                    @change="select()"
                    :value="'99'"
                    :unchecked-value="''"
                    v-model="searchForm.payment_method"
                  >
                    <small>Outros </small>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
    <hr/>
    <div class="row">
      <div class="col-md-12">
        <account-transaction-list
          :account-transactions="transactions"
          @pagechange="handlePageChange($event)"
          @openBillPaymentModal="openBillPaymentModal($event)"
          @cancel="handleOpenAccountTransactionCancelForm($event)"
        />
      </div>
    </div>
    <!-- table list -->
    <br />
    <!-- <table-paginator :data="transactions" @pagechange="select($event)">
			<div class="row grid-table-heading">
				<div class="col-md-1">Data</div>
				<div class="col-md-4">Descrição</div>
				<div class="col-md-2">Plano de contas</div>
				<div class="col-md-1"></div>
				<div class="col-md-3 d-flex" style="padding: 0px">
					<div class="col-6 text-right">Valor</div>
					<div class="col-6 text-right">Saldo</div>
				</div>
				<div class="col-md-1 text-right"></div>
			</div>
			<hr />
			<template v-for="row in transactions.data">
				<div
					class="row grid-table-row d-flex align-items-center"
					@click="openBillPaymentModal(row.id)"
					:key="row.id"
					style="cursor: pointer"
				>
					<div class="col-md-1 order-1">
						<small>{{ row.paid_at | dateBr }}</small>
					</div>

					<div class="col-md-4 order-2 d-flex">
						<div>
							<span class="fa-stack">
								<i class="fas fa-circle fa-stack-2x text-muted"></i>
								<i
									:class="[origin[row.origin].icon, 'fa-stack-1x fa-inverse']"
								></i>
							</span>
						</div>
						<div class="ml-2">
							<span>{{ row.description }}</span>
							<button
								class="btn btn-sm btn-link text-info"
								v-if="row.origin == 'br'"
								@click.stop="openBillPaymentModal(row.id)"
							>
								Ver contas
							</button>
							<span v-if="row.status == 'c'" class="badge badge-danger ml-2"
								>Cancelado</span
							>
							<template v-if="row.account_plan_id">
								<br />
								<span>
									{{ row.account_plan_description }}
								</span>
							</template>
							<br />
							<small class="text-muted"
								>Criado em {{ row.created_at | dateTimeBr }}</small
							>
						</div>
					</div>

					<div class="col-md-2 order-3 d-md-inline d-none">
						<template v-if="row.account_plan_id">
							<span>{{ row.account_plan_description }}</span>
						</template>
						<template v-else>
							<span class="text-muted ml-2">-</span>
						</template>
					</div>

					<div class="col-md-1 col-2 order-md-4 order-5 text-center">
						<span
							:class="[
								'badge',
								'text-white',
								payment_method[row.payment_method].class
							]"
						>
							{{ payment_method[row.payment_method].text }}
						</span>
					</div>

					<div
						class="col-md-3 col-8 order-md-5 order-6 d-flex"
						style="padding: 0px"
					>
						<div
							:class="[
								'col-md-6 col-6 text-right',
								getValueTextClass(row.value, row.payment_method)
							]"
						>
							<b v-if="row.status == 'p'" style="font-size: 16px">{{
								row.value | decimal
							}}</b>
							<s class="text-muted" v-else>{{ row.value | decimal }}</s>
						</div>

						<div
							:class="[
								'col-md-6 col-6 text-right',
								getValueTextClass(row.balance, 1)
							]"
						>
							<span v-if="row.payment_method == 1 && row.status == 'p'">{{
								row.balance | decimal
							}}</span>
							<span v-else class="text-muted mr-2">-</span>
						</div>
					</div>

					<div class="col-md-1 col-2 order-md-6 order-4 text-right">
						<b-dropdown
							variant="light"
							right
							toggle-class="text-decoration-none ml-3"
							no-caret
							v-if="row.status != 'c' && row.payment_method == 1"
						>
							<template v-slot:button-content>
								<i class="fas fa-ellipsis-v text-muted" />
							</template>
							<b-dropdown-item
								v-if="accountTransactionCancel"
								@click.stop="openAccountTransactionCancelForm(row)"
							>
								<i class="fas fa-file-invoice" />
								Cancelar
							</b-dropdown-item>
						</b-dropdown>
					</div>
				</div>
			</template>
		</table-paginator> -->

    <!-- table list -->

    <error-handler :error="error" />
    <account-resume ref="accountResume" />
    <account-transaction-form
      @stored="select"
      ref="accountTransactionForm"
      :accountPlanOptions="account_plan_options"
    />
    <account-transfer-form ref="accountTransferForm" @stored="select" />
    <account-transaction-cancel-form
      ref="accountTransactionCancelForm"
      @cancelled="select(currentPage)"
    />
    <account-transaction-bill-paymentModal
      ref="accountTransactionBillPaymentModal"
    />
   </div>
</template>

<script>
import Filters from "@/mixins/Filters.js";
import AccountResume from "@/components/account/sections/AccountResume";
import AccountTransactionForm from "@/components/account/forms/AccountTransactionForm";
import AccountTransferForm from "@/components/account/forms/AccountTransferForm";
import TablePaginator from "@/components/sections/TablePaginator";
//import Avatar from "vue-avatar";
import AccountTransactionCancelForm from "@/components/account/forms/AccountTransactionCancelForm";
import AccountTransactionBillPaymentModal from "@/components/sections/AccountTransactionBillPaymentModal";
 import AccountTransactionList from "@/components/account/sections/AccountTransactionList.vue";

export default {
  components: {
    AccountTransactionList,
    AccountResume,
    TablePaginator,
    //Avatar,
    AccountTransactionForm,
    AccountTransferForm,
    AccountTransactionCancelForm,
    AccountTransactionBillPaymentModal,
   },

  data: function () {
    return {
      //account : null,

      showFilters: false,

      origin: {
        o: {
          text: "Vendas",
          icon: "fas fa-shopping-cart",
        },
        br: {
          text: "Contas a receber",
          icon: "fas fa-file-invoice-dollar",
        },
        bp: {
          text: "Contas a pagar",
          icon: "fas fa-file-invoice-dollar",
        },
        c: {
          text: "Lançamento",
          icon: "fas fa-pen",
        },
        t: {
          text: "Transferência",
          icon: "fas fa-exchange-alt",
        },
      },

      currentPage: 1,

      accountOptions: {},

      account_plan: {},

      account_plan_options: {},

      payment_method: {
        1: {
          text: "Dinheiro",
          class: "badge-success",
        },

        2: {
          text: "Cheque",
          class: "badge-success",
        },

        3: {
          text: "Cartão de Credito",
          class: "badge-secondary",
        },
        4: {
          text: "Cartão de Débito",
          class: "badge-secondary",
        },
        5: {
          text: "Crediário",
          class: "badge-secondary",
        },

        15: {
          text: "Boleto Bancário",
          class: "badge-secondary",
        },

        16: {
          text: "Depósito Bancário",
          class: "badge-secondary",
        },

      },

      status: {
        p: {
          text: "Processada",
          class: "badge-success",
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
      },

      searchForm: {
        account_id: null,
        name: null,
        paid_at_start: null,
        paid_at_end: null,
        created_at_start: null,
        created_at_end: null,
        payment_method: ["1", "2", "3", "4", "5", "15", "17", "18","99"],
        status: {},
        page: 1,
      },

      error: null,
    };
  },

  computed: {
    account() {
      return this.$store.getters["account/selectedAccount"];
    },

    selectedAccountId() {
      return this.searchForm.account_id;
    },

    accountPlan() {
      return this.$store.state.accountPlan.accountPlans;
    },

    canManageAccounts() {
      if (!this.$store.state.user) {
        return false;
      }

      if (
        this.$store.state.user.is_master_user != 1 &&
        this.$store.state.user.is_admin_user != 1
      ) {
        return false;
      }

      return true;
    },

    transactions() {
      return this.$store.state.accountTransaction.transactions;
    },
    accountTransactionCancel() {
      return this.$acl.can("accountTransactionCancel");
    },
  },

  watch: {
    account() {
      this.searchForm.account_id = this.account.id;
      this.select(1);
    },
  },

  mounted() {
    this.searchForm.account_id = this.account.id;
    this.select(1);
  },

  methods: {
    // setAccount(account) {
    //   this.account = account
    // },

    openAccountResume() {
      this.$refs.accountResume.open(this.searchForm.account_id);
    },

    insertAccountTransaction(account_id) {
      this.$refs.accountTransactionForm.open(account_id);
    },

    udpateAccountTransaction(accountTransactionId) {
      this.$refs.accountTransactionForm.open(
        this.searchForm.account_id,
        accountTransactionId
      );
    },

    openAccountTransaferForm(account_id) {
      this.$refs.accountTransferForm.open(account_id);
    },

    handleOpenAccountTransactionCancelForm(transaction) {
      this.$refs.accountTransactionCancelForm.open(transaction);
    },

 

    select(page = 1) {
      this.currentPage = page;

      this.searchForm.page = page;

      this.$store.commit("showLoading");

      this.$store
        .dispatch("accountTransaction/getTransactions", this.searchForm)
        .then((response) => {
          this.$store.commit("hideLoading");
        })

        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    handlePageChange(page) {
      this.select(page)
    },

    openBillPaymentModal(accountTransaction) {
      if (this.$acl.can("accountTransactionCreateEdit")) {
        this.$refs.accountTransactionBillPaymentModal.open(
          accountTransaction.id
        );
      }
    },
  },
};
</script>
